import { Component, Input, OnDestroy, OnInit, HostListener, ViewChild } from '@angular/core';
import {StreamProject, StreamChat} from "../../../interfaces";
import { SocketStreamsChat } from '../../../services/sockets'
import {StreamsService} from '../../../services/streams.service'
import {  NbToastrService, NbGlobalPosition,NbDialogService } from '@nebular/theme';
 import {ChatBlacklistModalComponent} from './chat-blacklist-modal/chat-blacklist-modal.component';

import {
  debounceTime 
} from "rxjs/operators";
 
@Component({
  selector: 'app-streamer-chat',
  templateUrl: './streamer-chat.component.html',
  styleUrls: ['./streamer-chat.component.scss']
})
export class StreamerChatComponent implements OnInit, OnDestroy {

 

  @Input() stream: StreamProject;
  @Input() openSettingsCb: any = null;
  public messages: any[] = [];
   
  chat$:any = null;
  chat:StreamChat = null;
  toggleEnabled$:any = null;
  chatEnabled:boolean = false
  reconnected: boolean = false
  user:any = false
  selectedMessage : any = null
  

  constructor( 
	private dialogService: NbDialogService,
    private socket: SocketStreamsChat,
    private streamsService : StreamsService,
    private toastrService: NbToastrService,
    ) {
     this.socket.removeAllListeners()
     this.socket.disconnect()
    }

  ngOnInit(): void {

    this.chatEnabled = this.stream.chatEnabled

    this.chat$ = this.streamsService.getOwnChat(this.stream._id)
    .subscribe((data:any)=>{


      this.chat = data.chat

	if(data.user?.name){  
	
		this.user = data.user

	}
      
      this.messages =  this.chat.messages.map(message=>{


        return {
	  _id: message._id,
           id: message.id,
	    token_type:message.token_type,
	   ip: message.ip,
          socialId: message.socialUserIdentity,
	  uid: message.uid,
          type: message.type,
          text: message.text,
          date: message.date,
          user: {
            name:  message.userInfo.name,
            avatar:  message.userInfo.avatar
          }

        }

      })  
       
 
    this.socket.on('connect', ()=>{
 
        this.socket.emit('onJoin',{
          data: this.chat._id
        })
    
    })
    
     
   

      //


      this.socket.on('onMessage', this.onMessage.bind(this))

	this.socket.on('onDelete', this.onDeleteMessage.bind(this))

           	this.socket.on('onBanUser', this.onBanUser.bind(this))
		
           	//this.socket.on('onBanMe', this.onBanMe.bind(this))

      this.socket.connect() 
    })

  }


	openSettings(){
	  this.openSettingsCb(true)
	}

  selectedMessageControl(cmd){
     let msg = this.selectedMessage
     this.selectedMessage = null

	

	if(cmd === 'delete'){
		this.socket.emit('deleteMessage', msg.id)
		
		return
       }

	if(cmd === 'ban'){ 
		 this.socket.emit('banUser',{uid: msg.uid, socIdent: msg.socialId, token_type: msg.token_type, ip: msg.ip, name: msg.user.name} )
		return
	}

  }
 
	 onDeleteMessage(id){
		this.messages = this.messages.filter(msg=> msg.id !== id)

	}

    onBanUser(socialId){

		this.messages = this.messages.filter(msg=> msg.socialId !== socialId)
	}

	 
  selectItem(e,msg:any){
      
     
      
       if(e.target.classList.contains('sender')){  
     
      e.stopPropagation()
	this.selectedMessage = msg 
       return false;
      }


  }
 
  @HostListener('document:click')
  close() {
    this.selectedMessage = null
  }   

  toggleEnabled(){

 
    this.toggleEnabled$ = this.streamsService
    .updateChatEnabled(this.stream._id,this.chatEnabled)
     .subscribe((stream : StreamProject)=>{

      this.stream = stream
      this.chatEnabled = stream.chatEnabled

    }, ()=>{
      this.chatEnabled = this.stream.chatEnabled
    })

    
  }



  onMessage(message){
    this.messages.push(message);
  } 
 

  sendMessage(event: any) {


	if(!this.user){

		  this.toastrService.show('','Налаштуйте канал щоб відповідати в чаті',{
		      status: 'warning',
		      icon: '',
		      position: <NbGlobalPosition>'bottom-end'
			})
		   
		return
	}
 
   /* const files = !event.files ? [] : event.files.map((file) => {
      return {
        url: file.src,
        type: file.type,
        icon: 'file-text-outline',
      };
    }); */

    this.socket.emit('message',{
      text: event.message,
      fromOwner:true,
     // date: new Date(),
     // reply: true,
     // type: files.length ? 'file' : 'text',
      type: 'text',
  user: this.user,
      //files: files, 
    

   })



    /*

    this.messages.push({ 
      text: event.message,
      date: new Date(),
      reply: true,
      type: files.length ? 'file' : 'text',
      files: files, 
      user:    {
        name: 'Владелец канала',
        avatar: 'assets/images/nick.png',
      }
 
    });
    */
  }




  openBlackLish(){

	this.dialogService.open(ChatBlacklistModalComponent, {
	     
	      context: {
		chat_id: this.chat._id, 
		socket: this.socket
 
	      },
	    });
 }


  
   download(){
	if(!this.messages.length) return;


	let data = ''

	for(let m of this.messages){
	  let d = (new Date(m.date)).toLocaleString()
	  data += `${d}\t${m.user.name}\t${m.text} \r\n`
	}

	this.saveTextAsFile(data, this.chat._id+'.txt')
  }

 
 
     saveTextAsFile (data, filename){

    if(!data) {
        console.error('Console.save: No data')
        return;
    }

    if(!filename) filename = 'file.txt'
	
	 

    var blob = new Blob([data], {type: 'text/plain'}),
        e    = document.createEvent('MouseEvents'),
        a    = document.createElement('a')
 

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        }
        else{
          var e = document.createEvent('MouseEvents'),
              a = document.createElement('a');

          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
         /* e.initEvent('click', true, false, window,
              0, 0, 0, 0, 0, false, false, false, false, 0, null); */
		e.initEvent('click')
          a.dispatchEvent(e);
        }
  }

  

  ngOnDestroy(){

    if(this.toggleEnabled$){
      this.toggleEnabled$.unsubscribe()
    }
    if(this.chat$){
      this.chat$.unsubscribe()
    }


    //this.socket.removeAllListeners()
 
    this.socket.removeAllListeners()
	     
 
    this.socket.disconnect()
  }

}
 
